import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import {
  TipoFuncionalidade,
  TipoValidacaoCadastral,
  ValidacaoCadastroModalComponent,
  ValidacaoCadastroModalData
} from 'src/app/shared/components/validacao-cadastro-modal/validacao-cadastro-modal.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { listaUF } from 'src/app/shared/models/lista-uf.model';
import { ModalWrapperData } from 'src/app/shared/models/modal-wrapper-data.model';
import PerfilClienteEndereco from 'src/app/shared/models/perfil-cliente-endereco.model';
import PerfilCliente from 'src/app/shared/models/perfil-cliente.model';
import { TipoAlteracao } from 'src/app/shared/models/tipo-alteracao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { EnderecoService } from 'src/app/shared/services/endereco.service';
import { PasswordRecoveryService } from 'src/app/shared/services/password-recovery.service';
import { ToastService } from 'src/app/shared/toast';
import StringUtils from 'src/app/shared/utils/string-utils';
import { PerfilService } from '../perfil.service';
import { TipoAlteracaoPerfilEnum } from '../selecao-canal-validacao-page/selecao-canal-validacao-page.component';

@Component({
  selector: 'app-perfil-page-component',
  templateUrl: './perfil-page-component.component.html',
  styleUrls: ['./perfil-page-component.component.scss']
})
export class PerfilPageComponentComponent implements OnInit {

  constructor(
    private perfilService: PerfilService,
    private loaderService: LoaderService,
    private autenticacaoService: AutenticacaoService,
    private enderecoService: EnderecoService,
    private router: Router,
    private baseModalService: BaseModalService,
    private toastService: ToastService,
    private breakpointObserver: BreakpointObserver,
    private passwordRecoveryService: PasswordRecoveryService,
  ) {
  }

  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  get temColaboradorAutenticado() {
    return !!this.autenticacaoService.temColaboradorAutenticado();
  }

  clientePerfil = new PerfilCliente();
  usuario = new Usuario();
  TipoAlteracao = TipoAlteracao;
  TipoValidacaoCadastral = TipoValidacaoCadastral;
  listaUf = listaUF;
  CEP_LENGTH = 8;
  disabledEndereco = true;
  disabledBairro = true;
  disabledUf = true;
  disabledCidade = true;
  modalValidacaoRef: MatDialogRef<any>;
  private readonly HTTP_BUSSINESS_ERROR = 422;
  TipoAlteracaoPerfilEnum = TipoAlteracaoPerfilEnum;

  @ViewChild('form') form: NgForm;

  fieldsWithFocus = [];

  ngOnInit(): void {
    this.buscarClientePerfil();
    this.passwordRecoveryService.clearStorageData();

    const state = history.state;

    if (state?.showUpdateProfileModal) {
      this.showAtualizarPerfilModal(state?.showUpdateProfileModal);
    }
  }

  get securityAlertText() {
    if (!this.clientePerfil.celular && !this.clientePerfil.email) {
      return { icon: 'error_outline', title: 'Importante!', text: 'Por favor, adicione o seu número de celular e e-mail.' };
    }

    if (!this.clientePerfil.email) {
      return { icon: 'label_important', title: 'Lembre-se', text: 'de manter seu cadastro sempre atualizado.' };
    }

    if (!this.clientePerfil.celular) {
      return { icon: 'error_outline', title: 'Importante!', text: 'Por favor, adicione o seu número de celular.' };
    }

    return { icon: 'label_important', title: 'Lembre-se', text: 'de manter seu cadastro sempre atualizado.' };
  }

  async buscarClientePerfil() {
    try {
      this.loaderService.start();
      const clientePerfil = await this.perfilService.getPerfil();
      if (clientePerfil) {
        this.clientePerfil = clientePerfil;
        if (this.clientePerfil.celular) {
          this.clientePerfil.celular = this.clientePerfil.celular.startsWith('+')
            ? this.clientePerfil.celular.substring(3)
            : this.clientePerfil.celular.substring(2);
        }
      }
    } catch (response) {
      this.toastService.show({ title: 'Não foi possivel buscar os dados do perfil.', text: 'Tente novamente mais tarde!', type: 'error' });
    } finally {
      this.loaderService.stop();
    }
  }

  async salvarDadosBasicos() {
    try {
      this.loaderService.start();
      if (!this.temColaboradorAutenticado) {
        const { email, celular, ...dadosBasicos } = this.clientePerfil;
        await this.perfilService.alterarDadosBasicos(dadosBasicos);
      } else {
        const { ...dadosBasicos } = this.clientePerfil;
        dadosBasicos.celular = `+55${dadosBasicos.celular}`;
        dadosBasicos.nome = dadosBasicos.nome.trim();
        await this.perfilService.alterarDadosBasicos(dadosBasicos);
      }
      this.toastService.show({ title: 'Perfil atualizado!', text: 'Informação salva com sucesso.', type: 'success' });
      this.buscarClientePerfil();
    } catch (response) {
      this.toastService.show({ title: 'Não foi possível atualizar o seu perfil.', text: 'Erro ao salvar as informações.', type: 'error' });
    } finally {
      this.loaderService.stop();
    }
  }

  goToSelectValidationTypePage(tipo: TipoAlteracaoPerfilEnum) {
    this.router.navigate([`/portal/perfil/validacao/alterar/${tipo.toLowerCase()}`]);
  }

  async showAtualizarPerfilModal(tipo: TipoValidacaoCadastral) {
    const dataPhone: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: this.clientePerfil.celular ? 'Alterar celular' : 'Adicionar celular',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: true, width: '100%', maxWidth: '643px' },
      data: {
        tipo,
        funcionalidade: this.clientePerfil.celular ? TipoFuncionalidade.ALTERACAO : TipoFuncionalidade.CADASTRO,
        initialValue: this.clientePerfil.celular,
      }
    };

    const dataEmail: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: this.clientePerfil.email ? 'Alterar e-mail' : 'Adicionar e-mail',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: true, width: '100%', maxWidth: '643px' },
      data: {
        tipo,
        funcionalidade: this.clientePerfil.email ? TipoFuncionalidade.ALTERACAO : TipoFuncionalidade.CADASTRO,
        initialValue: this.clientePerfil.email,
      }
    };

    const data = tipo === TipoValidacaoCadastral.EMAIL ? dataEmail : dataPhone;

    this.modalValidacaoRef = this.baseModalService.showModal(data);

    const modalResponse: { valido: boolean, showConfirmationModal?: boolean } = await this.modalValidacaoRef.afterClosed().toPromise();

    if (modalResponse.valido) {
      this.buscarClientePerfil();
    }
  }

  voltarAoInicio() {
    this.router.navigate(['/portal/contratos'], { state: { confirmDeactivate: this.form.dirty } });
  }

  trimZeroAEsquerda(numero: any) {
    const trimNumero = numero.toString().replace(/\b0+/g, '');
    this.clientePerfil.endereco.numero = trimNumero;
  }

  async buscarEndereco(event: Event): Promise<void> {
    const cep = (event.target as HTMLInputElement).value
    const normalizedCep = StringUtils.normalize(cep);

    if (normalizedCep.length === this.CEP_LENGTH) {
      try {
        this.loaderService.start();
        const endereco = await this.enderecoService.buscarEnderecoPorCep(normalizedCep);
        this.clientePerfil.endereco.bairro = endereco.bairro;
        this.clientePerfil.endereco.cidade = endereco.municipio;
        this.clientePerfil.endereco.endereco = endereco.logradouro;
        this.clientePerfil.endereco.uf = endereco.estado;
        this.clientePerfil.endereco.numero = null;
        this.clientePerfil.endereco.complemento = null;

        this.disabledBairro = (!!endereco && !!endereco.bairro);
        this.disabledEndereco = (!!endereco && !!endereco.logradouro);
        this.disabledUf = (!!endereco && !!endereco.estado);
        this.disabledCidade = (!!endereco && !!endereco.municipio);
      } catch (response) {
        this.disabledBairro = false;
        this.disabledEndereco = false;
        this.disabledUf = false;
        this.disabledCidade = false;
        this.clientePerfil.endereco = new PerfilClienteEndereco();

        if (response.status === this.HTTP_BUSSINESS_ERROR) {
          const isCepNotFound = response.error.message.includes('encontrado');
          if (isCepNotFound) {
            setTimeout(() => {
              this.form.controls.inputCep.markAllAsTouched();
              this.form.controls.inputCep.setErrors({ cepNotFound: true });
            });
          } else {
            this.toastService.show({ title: 'Não foi possível buscar as informações do CEP informado.', text: 'Digite as informações de endereço manualmente.', type: 'error' });
          }
        } else {
          this.toastService.show({ title: 'Não foi possível buscar as informações do CEP informado.', text: 'Digite as informações de endereço manualmente.', type: 'error' });
        }
      } finally {
        this.loaderService.stop();
      }
    }
  }

  setFocus(fieldname: string) {
    this.fieldsWithFocus.push(fieldname);
  }

  removeFocus(fieldname: string) {
    this.fieldsWithFocus = this.fieldsWithFocus.filter((field) => field !== fieldname);
  }

  hasFocus(fieldname: string) {
    return this.fieldsWithFocus.includes(fieldname);
  }

  clearField(control: any, fieldName: string) {
    control.setValue('');
    this.removeFocus(fieldName);
  }

}
